module.exports = __webpack_public_path__ + "img/content-blocks.b591d97a.svg";